<!-- <body
  class="layout nb-layout vertical-layout vertical-menu-modern 1-column navbar-floating footer-static bg-full-screen-image blank-page"
  data-open="click" data-menu="vertical-menu-modern" data-col="1-column"
  style="margin: 0; padding: 0; height: 100vh; overflow: hidden;">
  <div class="app-content content" style="height: 100%; overflow: hidden;margin-left: 20px;">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper" style="height: 100%; display: flex; justify-content: center; align-items: center;">
      <div class="content-body" style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
        <section class="row flexbox-container" style="width: 100%; height: 100%; overflow-y: auto; padding: 20px;">
          <div class="card" style="width: 100%; max-width: 1400px; height: 130vh; overflow: hidden; box-shadow: 0px 4px 10px rgba(0,0,0,0.1);">
            <div class="card-header " style="background-color: #e4ecf5; color: white; padding: 10px; min-height: 74px;">
              <div class="row">
                <div class="col-md-5">
                    <div class=" logo-container " style="margin-top: -17px;"> <br><img src="../../assets/images/Airlinegstlogo.png" alt="Logo" style="width: auto;margin-left: 16px;padding-bottom: 10px;"/>
                    </div>
                </div>
                <div class="col-md-7" style="text-align: center;">
              <h2 class="mb-0" style="font-size: 1.5rem; text-align:justify;">Terms and Conditions</h2> 
                </div>
              </div>
            </div>
            <form [formGroup]="Termsconditions" class="form-valide">
              <div class="row "style="border:none;margin:0px;">
                <div class="col-sm-12">
                  <div class="form-group">
                    <textarea rows="4" cols="50" style="overflow-y: scroll;"
                      nbInput
                      fullWidth
                      formControlName="Content"
                      rows="10"
                      maxlength="maxlength"
                      fieldSize="small"
                      [status]="(submitted && f.Content.errors) ? 'danger' : 'basic'"
                      placeholder=""
                      style="resize: vertical; overflow-y: auto; height: auto; min-height: 650px;"
                    >
                    </textarea>
                    <ng-container *ngIf="submitted && f.Content.errors" class="invalid-feedback">
                      <p class="caption status-danger" *ngIf="f.Content.errors.required">
                        Content is required
                      </p>
                    </ng-container>
                  </div>
                </div>
              </div> 
            </form>
          </div>
        </section>
      </div>
    </div>
  </div>
</body> -->

<body 
  class="layout nb-layout vertical-layout vertical-menu-modern 1-column navbar-floating footer-static bg-full-screen-image blank-page"
  data-open="click" data-menu="vertical-menu-modern" data-col="1-column"
  style="margin: 0; padding: 0; height: 100vh; overflow: hidden;">
  <div class="app-content content" style="height: 100%; overflow: hidden; margin-left: 20px;">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper d-flex justify-content-center align-items-center" style="height: 100%;">
      <div class="content-body d-flex justify-content-center align-items-center w-100 h-100">
        <section class="row flexbox-container w-100 h-100 overflow-auto p-3">
          <div class="card w-100" style="max-width: 1400px; height: auto; min-height: 80vh; box-shadow: 0px 4px 10px rgba(0,0,0,0.1);">
            <div class="card-header bg-light text-white py-3" style="min-height: 74px;">
              <div class="row align-items-center">
                <!-- <div class="col-md-5 text-center text-md-start">
                  <img src="../../assets/images/Airlinegstlogo.png" alt="Logo" class="img-fluid" style="max-width: 150px;"/>
                </div> -->
                <div class="col-md-8 col-lg-12 text-center">
                  <h2 class="mb-0" style="font-size: 1.5rem; ">Terms and Conditions</h2>
                </div>
              </div>
            </div>
            <form [formGroup]="Termsconditions" class="form-valide p-3">
              <div class="row m-0">
                <div class="col-sm-12">
                  <div class="form-group">
                    <textarea 
                      class="form-control" 
                      style="resize: vertical; overflow-y: auto; min-height: 84vh; max-height: 90vh;" 
                      nbInput fullWidth 
                      formControlName="Content" 
                      rows="10" 
                      maxlength="maxlength" 
                      fieldSize="small" 
                      [status]="(submitted && f.Content.errors) ? 'danger' : 'basic'"
                      placeholder="">
                    </textarea>
                    <ng-container *ngIf="submitted && f.Content.errors" class="invalid-feedback">
                      <p class="caption status-danger" *ngIf="f.Content.errors.required">
                        Content is required
                      </p>
                    </ng-container>
                  </div>
                </div>
              </div> 
            </form>
          </div>
        </section>
      </div>
    </div>
  </div>
</body>
